import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { EmbedDocumentsContainer } from '@containers/EmbedDocumentsContainer';
import { PageContainer } from './EmbedDocuments.styles';

export default function EmbedDocuments() {
  return (
    <PageContainer>
      <PageHeader 
        title="Embed Documents" 
        description="Upload and manage your legal documents for AI-powered searching and analysis."
      />
      <EmbedDocumentsContainer />
    </PageContainer>
  );
};